import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { GET_PROGRAM_INVENTORY, GET_PROGRAM_INVENTORY_ERROR, GET_PROGRAM_INVENTORY_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getProgramInventory({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/inventory/summary`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.params,
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROGRAM_INVENTORY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PROGRAM_INVENTORY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROGRAM_INVENTORY_ERROR, payload: error });
  }
}

export function* watchGetProgramInventory() {
  yield takeEvery(GET_PROGRAM_INVENTORY, getProgramInventory);
}

function* getProgramInventorySaga() {
  yield all([fork(watchGetProgramInventory)]);
}

export default getProgramInventorySaga;
